module.exports = __webpack_public_path__ + "static/img/YF_H5.85201f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/company-logo/YF_H5.png
// module id = POz0
// module chunks = 34